import { Component, OnInit, HostListener, Inject, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { HotelhomeService } from '../../hotelhome/services/hotelhome.service';
import { Router,ActivatedRoute } from '@angular/router';
import { CommonService } from "../../services/common.service";
import { PopupComponent } from '../../dialogs/popup/popup.component';
import {NgbDate, NgbCalendar} from '@ng-bootstrap/ng-bootstrap';
import { RoomSearchService } from '../../room-search/room-search.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as _moment from 'moment';
import { AuthService } from '../../shared/providers/auth.service';
import { HotelDialogComponent } from '../hotel-dialog/hotel-dialog.component';
import { EventEmitterService } from '../../event-emitter.service';
import { HomeService } from '../../home/services/home.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @ViewChild('header', { static: false }) header: ElementRef;
	@ViewChild('popupcart', { static: false }) popupcart: ElementRef;
  @ViewChild('popupcalendar', { static: false }) popupcalendar: ElementRef;
  @ViewChild('giftcard', { static: false }) giftcard: ElementRef;
  public cartClass:string = 'roomDetail';
  headerHeight: number;
  DropDownHeight: number = 0;
  searchshow: boolean= false;
  showLoader: boolean= false;
  menuToggle: boolean= false;
  showDropDown: boolean= false;
  showCartDropDown: boolean= false;
  showCalendarDropDown: boolean= false;
  public hotelData:any = {};
  public totalCartItems;
  private popupcartHeight;
  private popupcalendarHeight;
  private cartSubscription;
  private isUserLoggedin:boolean = false;
  private loggedInStatus:any;
  private isLoggedIn:boolean = false;
  private calendarSearch;
  public hotelsData:any;
  public modifyReservation:boolean = false;
  public showCalenderForModification:boolean = false;
  private showCalenderMode;
  public commonLoaderSub:any
  public showCommonLoader:boolean = false;
  public logInsubscription:any;
  public showGFDropDown:boolean = false;
  public giftcardHeight:any;
  private cartpopup;
  changeRoute(hotel_code){
    this.ClosePopUp();
    this.showCommonLoader =true;
    this.router.navigate(['hotel/'+hotel_code]);
  }
  goToNewState(state){
    this.ClosePopUp();
    let currentUrl;
    if(state.indexOf('/') == 0) {
      currentUrl = this.router.url.slice(0);
    } else {
      currentUrl = this.router.url.slice(1);
    }
    if(currentUrl != state) {
      // this.showCommonLoader =true;
    }
    
    this.router.navigate([state]);
  }
  gotoHome(){
    this.ClosePopUp();
     this.router.navigate(['']);
  }
  manageBookings(){
    this.ClosePopUp();
    this.router.navigate(['manage-bookings']);
  }

  constructor(
    public dialog: MatDialog,
    private searchService: RoomSearchService,
    private router: Router,
    private homeService :HomeService,
    private hotelhomeService: HotelhomeService,
    private commonService: CommonService,
    private authService: AuthService,
    private eventEmitterService: EventEmitterService
  ) {
    document.documentElement.style.setProperty("--blk-shd1", "#2d323e"); 
    this.cartSubscription = this.commonService.totalCartCount.subscribe((cart:any) => {
      this.totalCartItems = cart.cartCount;
      if(this.totalCartItems === undefined || this.totalCartItems ===''){
        this.totalCartItems = 0;
      }
      if(this.showCartDropDown && this.totalCartItems === 0){
        this.ClosePopUp();
      }
    }); 

    this.calendarSearch = this.commonService.calendarSearchStatus.subscribe((status:any) => {
      if(status && this.showCalendarDropDown){
        this.ClosePopUp();
      }
    });

     this.cartpopup = this.commonService.showCart.subscribe((cart:any) => {
      if(typeof cart !== 'object' && cart !== undefined && cart !== null && cart !==''){
          if(cart){
            this.showCart();
            this.commonService.updateshowCart(false);
          }
      }
    });
    
    this.homeService.getFeaturedImages().then((data:any) => {
          if(data.status == 'success'){
            this.hotelsData= data.data;
            this.commonService.updateHotelsData(this.hotelsData);
          }
    });


    this.logInsubscription = this.commonService.userloggedIn.subscribe(res=>{
      this.isLoggedIn = res ? true : false;
    });

    let userAuthentication = localStorage.getItem('AuthToken');
    if(userAuthentication && userAuthentication !== null && userAuthentication !== undefined) {
      this.isLoggedIn = true;
    } else {
      this.loggedInStatus = this.commonService.checkLoginStatus.subscribe((result:any) => {
        if(!result || typeof result ==='object' ) {
          this.isLoggedIn = false;
        } else {
           this.isLoggedIn = true;
        }
      });
    }
    

  }


  ngOnInit() {
    // Trigger click event emitter
    this.eventEmitterService.subsVar = this.eventEmitterService.invokeManageBookingEvent.subscribe(() => {  
      this.callHotelPopup();    
    });

    document.getElementById("overlayBlock").style.display = 'none';
    
    // Show loader  
    this.commonLoaderSub = this.commonService.commonLoader.subscribe((data)=>{
      if(data) {
        this.showCommonLoader = true;
      } else {
        this.showCommonLoader = false;
      } 
    });
  }

  ngOnDestroy() {
    if(this.commonLoaderSub)
    this.commonLoaderSub.unsubscribe();
  }

  ngAfterViewInit() {
      this.headerHeight = this.header.nativeElement.offsetHeight;
      document.getElementsByTagName("body")[0].style.paddingTop = this.headerHeight + 'px';
      this.DropDownHeight = document.getElementById('menu-hover-row').offsetHeight;
      
      // Popup cart height
      let popupcart = this.popupcart.nativeElement.offsetHeight;
      document.getElementById("popupcart").style.top = this.headerHeight + 'px';
      document.getElementById("popupcart").style.height = '0px';
      this.popupcartHeight = popupcart;

      // Popup Calendar height
      let popupcalendar = this.popupcalendar.nativeElement.offsetHeight;
      document.getElementById("popupcalendar").style.top = this.headerHeight + 'px';
      document.getElementById("popupcalendar").style.height = '0px';
      this.popupcalendarHeight = popupcalendar;
      document.getElementById("overlayBlock").style.display = 'none'; 


            // GF height
      let giftcard = this.giftcard.nativeElement.offsetHeight;
      document.getElementById("giftcard").style.top = this.headerHeight + 'px';
      document.getElementById("giftcard").style.height = '0px';
      this.giftcardHeight = giftcard;
      // this.showCalenderMode = this.commonService.showCalendar.subscribe((status:any) => {
      //   console.log(status);
      //   if(!this.modifyReservation && !this.showCalenderForModification && status !==  undefined && status !== null && status !==  'undefined'  && status === true ){
      //     this.modifyReservation = true;
      //     document.getElementById("popupcalendar").style.height = (this.popupcalendarHeight) +'px';  
      //     document.getElementById("overlayBlock").style.display = 'block';  
      //     this.commonService.updateshowCalendar(false);
      //   }
      // }); 
  }

  over(){
    document.getElementById('menuHeight1').style.padding =(30)+'px';
    document.getElementById('menuHeight1').style.height =(this.DropDownHeight+60)+'px';
    document.getElementById('menuHeight1').style.display ='block';
    this.ClosePopUp();
  }

  out(){
     document.getElementById('menuHeight1').style.height = 0+'px';
     document.getElementById('menuHeight1').style.padding ='0px 30px 0px 30px';
     // document.getElementById('menuHeight').style.padding-bottom =(0)+'px';
  }

  
  /********************
  * To show Cart Data *
  ********************/
  showCart(){
    this.showCalendarDropDown = false;
    this.showGFDropDown = false;
    if(this.menuToggle){
      this.menuToggle = false
    }
    var mupog = localStorage.getItem('mupog');
    if(document.getElementById("popupcalendar") instanceof HTMLElement){
        document.getElementById("popupcalendar").style.height = '0px';
    }
    if(document.getElementById("giftcard") instanceof HTMLElement){
      document.getElementById("giftcard").style.height = '0px';
    }
    this.showCartDropDown = !this.showCartDropDown;
    if(this.showCartDropDown ){
      if(mupog != undefined && mupog !=''){
        document.getElementById("popupcart").style.height ='max-content';  
        document.getElementById("overlayBlock").style.display = 'block'; 
      } else {
          this.showCalender();
      }
    } else {
      document.getElementById("popupcart").style.height = '0px';
      document.getElementById("overlayBlock").style.display = 'none'; 
    }
  }

  /*************************
  * To close all Dropdown   *
  **************************/
  ClosePopUp(){
    if(this.showCalendarDropDown){
      this.showCalender();
    } else if(this.showCartDropDown){
      this.showCart();
    } else if(this.showGFDropDown){
      this.showGiftCard();
    }
  }

  /******************************
  * To Show Calendar Dropdown   *
  *******************************/
  showCalender(){
    this.showCartDropDown = false;
    this.showGFDropDown = false;
    document.getElementById("popupcart").style.height = '0px';
    document.getElementById("giftcard").style.height = '0px';
    this.showCalendarDropDown = !this.showCalendarDropDown;
    if(this.menuToggle){
      this.menuToggle = false
    }
    if(this.showCalendarDropDown){
      // Add day cell height equal to width  
      let dayCell = document.querySelector('.ngb-dp-day');
      if (dayCell instanceof HTMLElement) { 
        let offsetHeight = (dayCell.offsetWidth -2)+'px';
        let days = document.getElementsByClassName('ngb-dp-day');
        for(let i = 0; i < days.length; i++) {
          days[i].setAttribute('style','height:'+offsetHeight+' !important');
        }
      }

      document.getElementById("popupcalendar").style.height = (this.popupcalendarHeight) +'px';  
      document.getElementById("overlayBlock").style.display = 'block';  
    } else {
      document.getElementById("popupcalendar").style.height = '0px';
      document.getElementById("overlayBlock").style.display = 'none'; 
    }
  }

  showGiftCard(){
    this.showCartDropDown = false;
    this.showCalendarDropDown = false;
    if(this.menuToggle){
      this.menuToggle = false
    }
    document.getElementById("popupcart").style.height = '0px';
    document.getElementById("popupcalendar").style.height = '0px';
    this.showGFDropDown = !this.showGFDropDown;
    if(this.showGFDropDown){
      document.getElementById("giftcard").style.height = (this.giftcardHeight+this.headerHeight) +'px'; 
      document.getElementById("overlayBlock").style.display = 'block'; 
    } else {
      document.getElementById("giftcard").style.height = '0px';
      document.getElementById("overlayBlock").style.display = 'none'; 
    }
  }


  @HostListener('window:scroll', ['$event'])
 	onWindowScroll = (e) => {
    if (window.pageYOffset > this.headerHeight) {
       let element = document.getElementById('header');
       element.classList.add('sticky');
     } else {
      let element = document.getElementById('header');
        element.classList.remove('sticky');
     }
  }
  search(){
    this.ClosePopUp();
    this.searchshow = !this.searchshow;  
  }

  /******************************
  * For Toggling of Hotels menu *
  *******************************/
  toggleHotelDrop(){
    this.ClosePopUp();
    this.showDropDown = !this.showDropDown;
  }

  /******************************
  * For Toggling of mobile menu *
  *******************************/
  toggleMenu(){
    this.ClosePopUp();
    this.menuToggle = !this.menuToggle;  
  }

  /******************************/
  /*********** Logout ***********/
  /******************************/
  callLogout() {
    this.isLoggedIn = false;
    this.authService.logout();
    this.commonService.updateCartData(0);
    this.authService.updateLoggedInStatus(false);
    this.commonService.updateLoggedInStatus(false);
    this.commonService.isLoggedIn.next(false);
  }

  /******************************/
  /********* HotelPopup *********/
  /******************************/
  callHotelPopup() {
    this.ClosePopUp();
    // const dialogRef = this.dialog.open(HotelDialogComponent,{
    //   width: '450px'
    // });
    // dialogRef.afterClosed().subscribe(res => {
    //   if(res !== undefined && res !== null && res !=='' && res.hotel !== undefined){
    //     localStorage.setItem('manageBookingHotel', JSON.stringify({'hotel':res.hotel.hotel_code}));
    //     localStorage.setItem('manageBookingHotelId', res.hotel.hotel_id);
    //     this.router.navigate(['/manage-bookings']);

    //   }
    // });
    this.router.navigate(['/manage-bookings']);
  }

}
